import React, { Component } from 'react';
import { Card, BreadCrumb, LimitEdit } from '../../components';
import { Translate } from '../../contexts/Language';
import { Config } from '../../config';
import { Service } from '../../services';

export class DailyLimit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dailyLimit: [],
    };
  }

  componentDidMount() {
    Config.utilities.loadingFetch();

    Service.TransferOptions.DailyLimit().then(response => {
      if (response) {
        this.setState({
          dailyLimit: response,
        });
      }

      Config.utilities.loadingFetch();
    });
  }

  render() {
    const { dailyLimit } = this.state;
    return (
      <>
        <BreadCrumb Title={Translate('Daily Limit')} Name={Translate('Daily Limit')} />
        <Card Title="Payment Service Daily Limit" Description="Customer panel payment systems user daily limit.">
          <div className="row">
            {dailyLimit.map((item, index) => (
              <LimitEdit key={index} Data={item} />
            ))}
          </div>
        </Card>
      </>
    );
  }
}
